









































import TableComp from '@/components/Common/TableComp.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'studentEnglishScore',
  components: {
    TableComp
  }
})
export default class extends Vue {
  @Prop() public tableData!: any;
}
